import { BaseRemittanceNewMember } from './base-remittance-new-member';

export class RemittanceNewMember extends BaseRemittanceNewMember {
  public remittanceId!: number;
}
